import { getUser } from "./index.js";
import { getNationalIdInMemory } from "./userPiiMemory.js";

const getUserData = () => {
	const user = getUser();

	if (!user) return null;

	const cpf = getNationalIdInMemory(user) || user.custom?.nationalId || user["custom:nationalId"];
	const email = user.email;
	const username = user.username;

	return {
		cpf,
		username,
		email,
	};
};

const sendAntifraudeAnalysis = (action) => {
	const token = window.ANTIFRAUDE_TOKEN;
	if (!token || token === "") {
		return;
	}

	const sdkInstance = window.__antifraudeSDKInstance;
	if (!sdkInstance) {
		return;
	}

	const userData = getUserData();
	if (!userData) {
		return;
	}

	const refIdGeoloc = window.MULTINATIONAL_TOKEN
		? window.MULTINATIONAL_TOKEN
		: window.TENANT === "mars"
			? "marsbet"
			: window.TENANT;

	try {
		console.log("[Antifraude SDK]: Sending analysis");
		sdkInstance.setAction(action);
		sdkInstance.sendAnalisys({
			username: userData.username,
			email: userData.email,
			cpf: userData.cpf,
			ref_id_geoloc: refIdGeoloc,
		});
	} catch (error) {
		console.error("[Antifraude SDK]: Failed to send analysis", error);
	}
};

export const sendSignin = () => sendAntifraudeAnalysis("signin");
export const sendSignup = () => sendAntifraudeAnalysis("signup");
export const sendDeposit = () => sendAntifraudeAnalysis("deposit");
export const sendWithdraw = () => sendAntifraudeAnalysis("withdraw");
export const sendCheck = () => sendAntifraudeAnalysis("check");
